import { useDisclosure } from '@chakra-ui/hooks';
import React, { useRef, useState } from 'react';
import firebase from '../Helpers/Firebase';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Button,
    Textarea
  } from "@chakra-ui/react"

  

const firestore = firebase.firestore();


export default function InitialFocus(props) {
  
    const initialRef = useRef();
    const finalRef = useRef();
    const hostsRef = firestore.collection('contacts');


    const initialValues = {
        fullName: '',
        phone: '',
        email: '',
        message: ''

    }

    const [values, setValues] = useState(initialValues);



    const handleChange = e => {
        var { name, value } = e.target;
        setValues({
            ...values, 
            [name]: value,
        })

    }

    const addUser = async(e) => {
        e.preventDefault();

        await hostsRef.add({
            fullName: values.fullName,
            phone: values.phone,
            email: values.email,
            message: values.message,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          });


        setValues({...initialValues});
        e.target.reset();
    }


    return (
        
      <div>

        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent m={4}>
              
            <ModalHeader>Contact Us</ModalHeader>
            <ModalCloseButton />
            <form onSubmit={addUser}>
            <ModalBody pb={6}>
              <FormControl >
                <FormLabel>Full name</FormLabel>
                <Input ref={initialRef} placeholder="Full Name" name="fullName" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Email</FormLabel>
                <Input ref={initialRef} placeholder="Phone Number" type="email" name="email" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Phone Number</FormLabel>
                <Input ref={initialRef} placeholder="Phone Number" type="tel" name="phone" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Message</FormLabel>
                <Textarea ref={initialRef} placeholder="What are you looking to host?"  name="message" onChange={handleChange} />
              </FormControl>

            </ModalBody>
            <ModalFooter>
              <Button  type="submit" colorScheme="blue" mr={3}>
                Submit
              </Button>
              <Button onClick={props.onClose}>Cancel</Button>
            </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </div>
    )
  }